import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import GoalGlyph from '@atlaskit/icon/core/goal';
import LegacyGoalIcon from '@atlaskit/legacy-custom-icons/goal-bold-icon';
export var GoalIcon = function GoalIcon(props) {
  return /*#__PURE__*/React.createElement(GoalGlyph, _extends({
    color: "var(--ds-icon, #44546F)",
    LEGACY_fallbackIcon: LegacyGoalIcon,
    spacing: "spacious"
  }, props));
};